export default {
  SET_STATES(state, states) {
    state.states = states
  },
  SET_CITIES(state, payload) {
    state.cities = payload
  }
}
